import React, { FC } from 'react';
import MuiMenu, { MenuProps as MuiMenuProps } from '@material-ui/core/Menu';
import { Uds } from '../../types';

export type MenuProps = Uds<MuiMenuProps & {}>;

export const Menu: FC<React.PropsWithChildren<MenuProps>> = ({ dataTest, ...props }) => (
  <MuiMenu data-test={dataTest} {...props} />
);
